import useWindowSize from "hooks/useWindowSize";
import "./group-view.scss";
import GroupViewItem from "./GroupViewItem";
export default function GroupViewContainer({ GroupViewData }) {
  const { width, height } = useWindowSize();

  if (false) {
    return (
      <div className="group-view-mobile mt-4">
        <ul className="nav nav-tabs border-0" id="myTab" role="tablist">
          {/* {GroupViewData.map((value, index) => {
            return (
              <li className="nav-item" role="presentation">
                <button className={`nav-link border-0 ${!index && "active"}`} id="home-tab" data-bs-toggle="tab" data-bs-target={`#tab-${index}`} type="button" role="tab" aria-controls="home" aria-selected="true">
                  {value.title}
                </button>
              </li>
            );
          })} */}
        </ul>
        <div className="tab-content" id="myTabContent">
          {GroupViewData.map((value, index) => {
            return (
              <div
                className={` tab-pane fade border-0 ${
                  !index && " show active"
                }`}
                id={`tab-${index}`}
                role="tabpanel"
              >
                <div>
                  {/* <GroupViewItem idConfig={value.idConfig} Component={value.Component} numberOf={value.numberOf} title={value.title} type={value.type} items={value.items} id={value.id} Color={value.Color} moreText={value.moreText} /> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <>
        {GroupViewData.map((value) => {
          return (
            <GroupViewItem
              idConfig={value.idConfig}
              Component={value.Component}
              numberOf={value.numberOf}
              title={value.title}
              type={value.type}
              id={value.id}
              Color={value.Color}
              moreText={value.moreText}
            />
          );
        })}
      </>
    );
  }
}
